// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-carousel_logo__NRJyh","lg":"logo-carousel_lg__YEbzP"};